import { render, staticRenderFns } from "./itemimpletemp.vue?vue&type=template&id=20117035&scoped=true&"
import script from "./itemimpletemp.vue?vue&type=script&lang=js&"
export * from "./itemimpletemp.vue?vue&type=script&lang=js&"
import style0 from "./itemimpletemp.vue?vue&type=style&index=0&id=20117035&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20117035",
  null
  
)

export default component.exports